<section class="main-content wrapper content-padding " style="margin-top: 50px;">
  <div class="content-panel">
    <div class="tabs">
      <label class="tab">
        <a class="tab-link active-tab">{{ settings[selected].title }}</a>
      </label>
    </div>

    <div class="item nowrap">
      <span class="btn-container top-button-container">

        <ng-template [ngIf]="selected == 'active'">
          <button class="btn vertical align-items-center" routerLink="/partner/fattura/storico">
            Storico<i class="ml-10 far fa-folder"></i>
          </button>
        </ng-template>

        <ng-template [ngIf]="selected == 'inactive'">
          <button class="btn vertical align-items-center" [routerLink]="['../']" [queryParams]="{navigation: 'back'}">
            <i class="ml-10 fas fa-arrow-left has-margin-right"></i>Ritorna a Fatturazione
          </button>
        </ng-template>

        <button class="btn btn-white vertical full-width-btn align-items-center" (click)="invoiceModal()">
          Genera Fattura<i class="ml-10 fas fa-file-pdf"></i>
        </button>

        <button class="btn btn-white vertical align-items-center" (click)="exportPartnerInvoice()" *ngIf="groups.includes('admin') || groups.includes('operation')">
          Esporta<i class="ml-10 fas fa-file-excel"></i>
        </button>

        <div class="vertical full-width-btn align-items-center" *ngIf="groups.includes('admin') || groups.includes('operation')">
          <select [(ngModel)]="selectedPartnerId" (ngModelChange)="handlePartnerChange($event)">
            <option [ngValue]="null" disabled selected>Select Partner</option>
            <option *ngFor="let partner of partners" [ngValue]="partner.id">{{ partner.businessName }}</option>
          </select>
        </div>

      </span>
    </div>

    <hr class="gold-hr">

    <section class="main-content wrapper scroll-delivery">
      <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>

        <div class="table-responsive-invoice has-margin-top" style="overflow-x: scroll;">
          <div class="custom-data-output has-margin-top" role="table" id="elencoConsegneAdmin">
            <form class="table-row-container row first-row filter" [formGroup]="_deliveryFilterForm" (ngSubmit)="filter()" *ngIf="_deliveryFilterForm">

              <div class="hide-on-mobile center data-col-{{selected == 'active' ? getSpacing('status') : getSpacing('historyStatus')}}">
                <h4 class="title">&nbsp;</h4>
                <span class="data">
                  &nbsp;
                </span>
              </div>
              <div class="hide-on-mobile item center data-col-{{selected == 'active' ? getSpacing('status') : getSpacing('historyStatus')}}">
                <h4 class="title">&nbsp;</h4>
                <span class="data">
                  &nbsp;
                </span>
              </div>

              <div class="hide-on-mobile item center data-col-5">
                <h4 class="title">&nbsp;</h4>
                <span class="data">
                  &nbsp;
                </span>
              </div>
              <div class="item center data-col-{{selected == 'active' ? getSpacing('status') : getSpacing('historyStatus')}}">
                <h4 class="title">STATO</h4>
                <span class="data">
                  <select formControlName="Delivery.status">
                    <option value="">Tutti</option>
                    <option *ngFor="let dSActive of deliveryStatusAux['forInvoiced']" [value]="dSActive">
                      {{deliveryStatusAux.ln('it', dSActive)}}
                    </option>
                  </select>
                </span>
              </div>

              <div class="item data-col-{{getSpacing('id')}}">
                <h4 class="title" (click)="navigateOrder('Delivery.ddtNumber')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('Delivery.ddtNumber')"></i>
                  ID VENDITA
                </h4>
                <span class="data">
                  <input type="text" formControlName="Delivery.ddtNumber" min="1000" max="10000" >
                </span>
              </div>

              <div class="item data-col-{{getSpacing('id')}}">
                <h4 class="title" (click)="navigateOrder('Delivery.id')">
                  <i class="sort-icon fas " [ngClass]="orderIcon('Delivery.id')"></i>
                  ID
                </h4>
                <span class="data">
                  <input type="number" formControlName="Delivery.id" min="1000" max="10000">
                </span>
              </div>

              <div class="item data-col-{{getSpacing('deliveryDate')}}">
                <h4 class="title" (click)="navigateOrder('Delivery.deliveryDate')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('Delivery.deliveryDate')"></i>
                  DATA
                </h4>
                <span class="data">
                  <div class="date">Da: </div>
                  <input class="date" type="date" formControlName="Delivery.deliveryDate_from">
                </span>
                <span class="data">
                  <div class="date">A: </div>
                  <input class="date" type="date" formControlName="Delivery.deliveryDate_to">
                </span>
              </div>

              <div class="item center data-col-{{getSpacing('time')}}">
                <h4 class="title" (click)="navigateOrder(['Delivery.fromTime'])">
                  <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.fromTime'])"></i>
                  ORARIO
                </h4>
                <span class="data">
                  <div class="date">Da: </div>
                  <input class="date" type="time" formControlName="Delivery.fromTime">
                </span>
                <span class="data">
                  <div class="date">A: </div>
                  <input class="date" type="time" formControlName="Delivery.toTime">
                </span>
              </div>

              <div class="item data-col-{{getSpacing('partner')}}" *ngIf="groupWhitelisted(['admin', 'expert'])">
                <h4 class="title" (click)="navigateOrder('Partner.businessName')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('Partner.businessName')"></i>
                  PARTNER
                </h4>
                <span class="data">
                  <input type="text" formControlName="Partner.businessName"
                    class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
                </span>
              </div>

              <div class="item data-col-{{getSpacing('expert')}}" *ngIf="groupWhitelisted('admin')">
                <h4 class="title" (click)="navigateOrder(['UserExpert.surname'])">
                  <i class="sort-icon fas" [ngClass]="orderIcon(['UserExpert.surname'])"></i>
                  EXPERT
                </h4>
                <span class="data"> <!-- DG  -->
                  <input type="text" formControlName="UserExpert.surname">
                </span>
              </div>

              <div class="item data-col-{{getSpacing('address')}}">
                <h4 class="title" (click)="navigateOrder(['Delivery.address'])">
                  <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.address'])"></i>
                  INDIRIZZO
                </h4>

                <span class="data">
                  <input type="text" formControlName="Delivery.address">
                </span>
              </div>

              <div class="item data-col-{{getSpacing('address')}}" *ngIf="groupWhitelisted('expert')">
                <h4 class="title">INDIRIZZO DI RITIRO</h4>
                <span class="data">
                  <input type="text" formControlName="Delivery.partner.address">
                </span>
              </div>
              <div class="item data-col-30 pickUpTime">
                <h4 class="title" (click)="navigateOrder(['Delivery.pickUpTime', 'Delivery.pickUpTime'])">
                  <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.pickUpTime', 'Delivery.pickUpTime'])"></i>
                  <!-- FASCIA ORARIO RITIRO -->
                  ORA RITIRO
                </h4>
                <span class="data">
                  <div class="date"></div>
                  <input class="date" type="time" formControlName="Delivery.pickUpTime">
                </span>
              </div>

              <!--
              <div class="item data-col-30" >
                <h4 class="title" (click)="navigateOrder(['Delivery.price', 'Delivery.price'])">
                  <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.price', 'Delivery.price'])"></i>
                  PREZZO</h4>
                <span class="data">
                  <input type="text" formControlName="Delivery.price">
                </span>
              </div>
              <div class="item data-col-30" >
                <h4 class="title" (click)="navigateOrder(['Delivery.additionalPrice', 'Delivery.additionalPrice'])">
                  <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.additionalPrice', 'Delivery.additionalPrice'])"></i>
                  PLUS MINUS PREZZO</h4>
                <span class="data">
                  <input type="text" formControlName="Delivery.additionalPrice">
                </span>
              </div>
              -->

              <div class="item center data-col-5">
                <h4 class="title">TIPO SERVIZIO</h4>
                <span class="data">
                  <select formControlName="Delivery.serviceType">
                    <option [selected]="true" [disabled]="true">Tipo servizio</option>
                    <option value="sales">Servizi Vendita</option>
                    <option value="hourlyrate">Servizi a Ora</option>
                    <option value="fixedprice">Servizi a Prezzo Fisso</option>
                    <option value="corporate">Servizio aziendale</option>
                    <option value="warehouseservice">Servizio Magazzino</option>
                  </select>
                </span>
              </div>

              <div class="item center data-col-30" *ngIf="groupWhitelisted(['admin', 'expert', 'partner'])">
                <h4 class="title">DA FATTURARE</h4>
                <span class="data">
                  <select formControlName="Delivery.billable" style="width: 120px;">
                    <option value="">Tutti</option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                </span>
              </div>

              <div class="item center data-col-30" *ngIf="groupWhitelisted(['admin', 'expert', 'partner'])">
                <h4 class="title">PAID WITH CARD</h4>
                <span class="data">
                  <select formControlName="Delivery.paidViaCard" style="width: 120px;">
                    <option value="">Tutti</option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                </span>
              </div>

              <div class="item data-col-" >
                <h4 class="title" (click)="navigateOrder(['Delivery.productValue', 'Delivery.productValue'])">
                  <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.productValue', 'Delivery.productValue'])"></i>
                  VALORE PRODOTTO</h4>
                <span class="data">
                  <input type="text" formControlName="Delivery.productValue">
                </span>
              </div>

              <div class="item data-col-" >
                <h4 class="title" (click)="navigateOrder(['Delivery.price', 'Delivery.price'])">
                  <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.price', 'Delivery.price'])"></i>
                  FEE %</h4>
                <span class="data">
                  <input type="text" formControlName="Delivery.price">
                </span>
              </div>

              <div class="item data-col-" >
                <h4 class="title" (click)="navigateOrder(['Delivery.price', 'Delivery.price'])">
                  <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.price', 'Delivery.price'])"></i>
                  PREZZO</h4>
                <span class="data">
                  <input type="text" formControlName="Delivery.price">
                </span>
              </div>

              <div class="item data-col-" >
                <h4 class="title" (click)="navigateOrder(['Delivery.additionalPrice', 'Delivery.additionalPrice'])">
                  <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.additionalPrice', 'Delivery.additionalPrice'])"></i>
                  PLUS MINUS PREZZO</h4>
                <span class="data">
                  <input type="text" formControlName="Delivery.additionalPrice">
                </span>
              </div>

              <div class="item data-col-" >
                <h4 class="title" (click)="navigateOrder(['Delivery.additionalPrice', 'Delivery.additionalPrice'])">
                  <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.additionalPrice', 'Delivery.additionalPrice'])"></i>
                  VALORE</h4>
                <span class="data">
                  <input type="text" formControlName="Delivery.additionalPrice">
                </span>
              </div>

              <div class="item data-col-" >
                <h4 class="title" (click)="navigateOrder(['Delivery.additionalPrice', 'Delivery.additionalPrice'])">
                  <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.additionalPrice', 'Delivery.additionalPrice'])"></i>
                  VALORE + IVA</h4>
                <span class="data">
                  <input type="text" formControlName="Delivery.additionalPrice">
                </span>
              </div>

              <div class="item data-col-" >
                <h4 class="title" (click)="navigateOrder(['Delivery.additionalPrice', 'Delivery.additionalPrice'])">
                  <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.additionalPrice', 'Delivery.additionalPrice'])"></i>
                  TOTALE</h4>
                <span class="data">
                  <input type="text" formControlName="Delivery.additionalPrice">
                </span>
              </div>

              <div class="item nowrap">
                <h4 class="title hide-on-mobile">AZIONI</h4>
                <span class="data-row-left btn-container">
                  <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
                    RICERCA <i class="fas fa-search"></i>
                  </button>
                    <br/>
                  <button class="btn vertical align-items-center" (click)="fnReset();">
                    RESET <i class="fas fa-times-circle"></i>
                  </button>
                </span>
              </div>
            </form>

            <div class="table-row-container row" *ngIf="deliveries.length">
              <div class="select-all">
                <input type="checkbox" id="checkAll" style="cursor: pointer;" [checked]="selectedDeliveries.length === deliveries.length" (change)="selectAllDeliveries()" />
                <label for="checkAll" style="cursor: pointer;">Seleziona Tutti</label>
              </div>
            </div>
            <div class="table-row-container row" *ngFor="let delivery of deliveries">

              <div class="item data-col-5">
                <span class="data-row-left">
                  <br>
                  <input type="checkbox" style="cursor: pointer;"  [id]="'checkbox_' + delivery.id" [checked]="isSelected(delivery)" (change)="toggleSelection(delivery)" />
                </span>
              </div>


              <div class="item data-col-{{selected == 'active' ? getSpacing('status') : getSpacing('historyStatus')}}">
                <span class="data-row-left">
                  <!-- <br>
                  <img src="favicon.ico" width="20" height="20" *ngIf="delivery.deluxyDelivery">
                  <br> -->
                  <a *ngIf="groupWhitelisted('admin')">
                    <span class="green-text" *ngIf="delivery.readDelivery && delivery.deliveryReadByPartner != null">
                      <i class="fa fa-check" aria-hidden="true"></i>&nbsp;
                    </span>
                    <span class="blue-text" *ngIf="delivery.readDelivery && delivery.deliveryReadByExpert != null">
                      <i class="fa fa-chevron-down" aria-hidden="true"></i>&nbsp;
                    </span>

                  </a>
                </span>
              </div>

              <div class="item center data-col-5">
                <h4 class="title">&nbsp;</h4>
                <img class="service-img" [src]="showServiceDetails(delivery?.service)?.image" width="40" height="40" *ngIf="showServiceDetails(delivery?.service)?.image">
              </div>

              <div class="item left-space data-col-{{selected == 'active' ? getSpacing('status') : getSpacing('historyStatus')}}">
                <span class="data-row-left">
                  <h4 class="title">STATO :</h4>
                  <a [ngClass]="delivery.status == 'delivering' ? 'blink' : ''">
                    <span class="dataGesture">
                      <span [matTooltip]="deliveryStatusAux.ln('it', delivery.status)" class="status {{deliveryStatusAux.css(delivery.status)}}"></span>
                      {{deliveryStatusAux.ln('it', delivery.status)}}
                    </span>
                  </a>
                </span>
              </div>

              <div class="item data-col-{{getSpacing('id')}}">

                <span class="data-row-left">
                  <h4 class="title table-title">ID VENDITA :</h4>
                  <a>
                    {{
                      delivery.correspondDelivery
                        ? delivery.correspondDelivery
                        : (delivery?.orderId && delivery?.externalOrderSource)
                          ? 'M' + delivery.orderId
                          : (delivery?.ddtNumber && !delivery?.externalOrderSource)
                            ? ((delivery.ddtNumber | saleName: delivery.shop) || delivery.ddtNumber)
                            : '---'
                    }}
                    <!-- {{ 
                      (delivery?.orderId && delivery?.externalOrderSource) 
                        ? 'M' + delivery.orderId 
                        : (
                            delivery?.ddtNumber && !delivery?.externalOrderSource
                          ) 
                            ? (delivery.ddtNumber | saleName: delivery.shop : delivery.ddtNumber) 
                            : '---' 
                    }}   -->
                  </a>
                </span>
              </div>

              <div class="item data-col-{{getSpacing('id')}}">

                <span class="data-row-left">
                  <h4 class="title table-title">ID :</h4>
                  <a>
                    {{delivery.id}}
                  </a>
                </span>
              </div>

              <div class="item data-col-{{getSpacing('deliveryDate')}}">
                <span class="data-row-left">
                  <h4 class="title table-title dataGesture">DATA :</h4>
                  <a>
                    {{delivery.deliveryDate | date:'dd/MM/yyyy'}}
                  </a>
                </span>
              </div>

              <div class="item center data-col-{{getSpacing('time')}}">
                <span class="data-row-left">
                  <h4 class="title table-title">ORARIO :</h4>
                  <a *ngIf="delivery.toTime != null">{{formatTimeShow(delivery.fromTime, delivery.toTime)}}</a>
                </span>
              </div>

              <div class="item data-col-{{getSpacing('partner')}}" *ngIf="groupWhitelisted(['admin', 'expert'])">
                <span class="data-row-left">
                  <h4 class="title table-title">PARTNER :</h4>
                  <a>
                    {{delivery.partner?.businessName}}
                  </a>
                </span>
              </div>

              <div class="item data-col-{{getSpacing('expert')}}" *ngIf="groupWhitelisted('admin')">
                <span class="data-row-left">
                  <h4 class="title table-title">EXPERT :</h4>
                  <a>
                    {{delivery.expert?.user?.surname}} {{delivery.expert?.user?.name}}
                  </a>
                </span>
              </div>

              <div class="item data-col-{{getSpacing('address')}}">
                <span class="data-row-left tick">
                  <h4 class="title table-title">INDIRIZZO :</h4>
                  <a>
                    {{((delivery.address ? delivery.address : "") + (delivery.city ? ", " + delivery.city : "")) || "---"}}
                  </a>
                </span>
              </div>

              <div class="item data-col-{{getSpacing('address')}}" *ngIf="groupWhitelisted('expert')">
                <span class="data-row-left">
                  <h4 class="title table-title">INDIRIZZO DI RITIRO :</h4>
                  <a>
                    {{delivery.partner?.address || "---"}}
                  </a>
                </span>
              </div>

              <div class="item data-col-30 pickUpTime">
                <span class="data-row-left">
                  <h4 class="title table-title">ORA RITIRO :</h4>
                  <a>
                    {{ delivery?.pickUpTime || "---"}}
                  </a>
                </span>
              </div>
              
              <!--
              <div class="item data-col-30 pickUpTime">
                <span class="data-row-left">
                  <h4 class="title table-title">PREZZO:</h4>
                  <a>
                    {{ 
                      delivery?.serviceType?.toLowerCase() != 'sales' ?
                      delivery?.price || "0€" :
                      delivery?.productValue + "€"
                    }}
                  </a>
                </span>
              </div>
              <div class="item data-col-30 pickUpTime">
                <span class="data-row-left">
                  <h4 class="title table-title">PLUS MINUS PREZZO:</h4>
                  <a>
                    {{ delivery?.additionalPrice || "0"}}€
                  </a>
                </span>
              </div>
              -->

              <div class="item left-space data-col-5">
                <span class="data-row-left">
                  <h4 class="title">TIPO SERVIZIO :</h4>
                  <a>
                    {{ delivery?.serviceType | serviceName }}
                  </a>
                </span>
              </div>

              <div class="item left-space data-col-30" *ngIf="groupWhitelisted(['admin', 'expert', 'partner'])">
                <span class="data-row-left">
                  <h4 class="title">DA FATTURARE :</h4>
                  <a>
                    {{
                      delivery?.billable ? "Yes" : "No"
                    }}
                  </a>
                </span>
              </div>

              <div class="item left-space data-col-30" *ngIf="groupWhitelisted(['admin', 'expert', 'partner'])">
                <span class="data-row-left">
                  <h4 class="title">PAID WITH CARD :</h4>
                  <a>
                    {{
                      delivery?.paidViaCard ? "Yes" : "No"
                    }}
                  </a>
                </span>
              </div>

              <div class="item data-col-30 pickUpTime">
                <span class="data-row-left">
                  <h4 class="title table-title">VALORE PRODOTTO:</h4>
                  <a>
                    {{ commanForValues(delivery).valoreProdotto | currency:'EUR' }}
                  </a>
                </span>
              </div>

              <div class="item data-col-30 pickUpTime">
                <span class="data-row-left">
                  <h4 class="title table-title">FEE %:</h4>
                  <a>
                    {{ commanForValues(delivery).fee }}%
                  </a>
                </span>
              </div>

              <div class="item data-col-30 pickUpTime">
                <span class="data-row-left">
                  <h4 class="title table-title">PREZZO:</h4>
                  <a>
                    {{ commanForValues(delivery).prezzo | currency:'EUR' }}
                  </a>
                </span>
              </div>

              <div class="item data-col-30 pickUpTime">
                <span class="data-row-left">
                  <h4 class="title table-title">PLUS MINUS PREZZO:</h4>
                  <a>
                    {{ commanForValues(delivery).plusMinusPrezzo | currency:'EUR' }}
                  </a>
                </span>
              </div>

              <div class="item data-col-30 pickUpTime">
                <span class="data-row-left">
                  <h4 class="title table-title">VALORE:</h4>
                  <a>
                    {{ commanForValues(delivery).valore | currency:'EUR' }}
                  </a>
                </span>
              </div>

              <div class="item data-col-30 pickUpTime">
                <span class="data-row-left">
                  <h4 class="title table-title">VALORE + IVA:</h4>
                  <a>
                    {{ commanForValues(delivery).valoreIva | currency:'EUR' }}
                  </a>
                </span>
              </div>

              <div class="item data-col-30 pickUpTime">
                <span class="data-row-left">
                  <h4 class="title table-title">TOTALE:</h4>
                  <a>
                    {{ commanForValues(delivery).totale | currency:'EUR' }}
                  </a>
                </span>
              </div>

              <div class="item nowrap">
                <span class="data-row-left btn-container">
                  <button class="btn vertical align-items-center" [routerLink]="['/consegne', delivery.id]">DETTAGLI</button>
                  <!-- <button class="btn vertical align-items-center" (click)="complainForDeliveryBilling(delivery)" *ngIf="groupWhitelisted('partner') && !delivery.invoiced" [disabled]="disableBtn">RECLAMA</button> -->
                  <button 
                    class="btn vertical align-items-center" 
                    (click)="complainForDeliveryBilling(delivery)" 
                    *ngIf="groupWhitelisted(['partner']) && !delivery?.invoiced && !complaintAlredayRegistered(delivery)" 
                    [disabled]="disableBtn">
                    RECLAMA
                  </button>
                  <a target="_blank" class="btn vertical align-items-center"   [routerLink]="['/consegne', delivery.id, 'edit']" *ngIf="groupWhitelisted('admin')">MODIFICA</a>
                  <button class="btn vertical align-items-center" [routerLink]="['/consegne', delivery.id, 'edit']" *ngIf="groupWhitelisted('partner') && (!delivery.deluxyDelivery) && (delivery.status == 'created' || delivery.status == 'delivered' || delivery.status == 'notDelivered')">MODIFICA</button>
                </span>
              </div>
            </div>

            <div class="table-row-container row total-row" *ngIf="deliveries.length">
              <div class="item data-col-5">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-" *ngIf="groupWhitelisted('admin')">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-" *ngIf="groupWhitelisted('admin')">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong>TOTALE</strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong>{{ grandTotalValues.valoreProdotto | currency:'EUR' }}</strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong>---</strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong>{{ grandTotalValues.prezzo | currency:'EUR' }}</strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong>{{ grandTotalValues.plusMinusPrezzo | currency:'EUR' }}</strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong>{{ grandTotalValues.valore | currency:'EUR' }}</strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong>{{ grandTotalValues.valoreIva | currency:'EUR' }}</strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong>{{ grandTotalValues.totale | currency:'EUR' }}</strong>
                  </a>
                </span>
              </div>

              <div class="item data-col-">
                <span class="data-row-left">
                  <a>
                    <strong></strong>
                  </a>
                </span>
              </div>
            
            </div>
          </div>
        </div>
    </section>
  </div>
</section>
    
<!--
<section class="title-bar content-padding first-item">
  <div class="wrapper nowrap">
    <h2 class="title-heading">{{ settings[selected].title }}</h2>
    <div class="item nowrap">
      <span class="btn-container top-button-container">

        <ng-template [ngIf]="selected == 'active'">
          <button class="btn vertical full-width-btn align-items-center" routerLink="/partner/fattura/storico">
            Storico<i class="ml-10 far fa-folder"></i>
          </button>
        </ng-template>

        <ng-template [ngIf]="selected == 'inactive'">
          <button class="btn vertical full-width-btn align-items-center" [routerLink]="['../']" [queryParams]="{navigation: 'back'}">
            <i class="ml-10 fas fa-arrow-left has-margin-right"></i>Ritorna a Fatturazione
          </button>
        </ng-template>

        <button class="btn btn-white vertical full-width-btn align-items-center" (click)="invoiceModal()">
          Genera Fattura<i class="ml-10 fas fa-file-pdf"></i>
        </button>

        <button class="btn btn-white vertical align-items-center" (click)="exportPartnerInvoice()" *ngIf="groups.includes('admin') || groups.includes('operation')">
          Esporta<i class="ml-10 fas fa-file-excel"></i>
        </button>

        <div class="vertical full-width-btn align-items-center" *ngIf="groups.includes('admin') || groups.includes('operation')">
          <select [(ngModel)]="selectedPartnerId" (ngModelChange)="handlePartnerChange($event)">
            <option [ngValue]="null" disabled selected>Select Partner</option>
            <option *ngFor="let partner of partners" [ngValue]="partner.id">{{ partner.businessName }}</option>
          </select>
        </div>

      </span>
    </div>
  </div>
</section>

<section class="main-content wrapper content-padding">
    <div class="table-responsive-invoice has-margin-top" style="overflow-x: scroll;">
      <div class="custom-data-output has-margin-top" role="table" id="elencoConsegneAdmin">
        <form class="table-row-container row first-row filter" [formGroup]="_deliveryFilterForm" (ngSubmit)="filter()" *ngIf="_deliveryFilterForm">

          <div class="hide-on-mobile center data-col-{{selected == 'active' ? getSpacing('status') : getSpacing('historyStatus')}}">
            <h4 class="title">&nbsp;</h4>
            <span class="data">
              &nbsp;
            </span>
          </div>
          <div class="hide-on-mobile item center data-col-{{selected == 'active' ? getSpacing('status') : getSpacing('historyStatus')}}">
            <h4 class="title">&nbsp;</h4>
            <span class="data">
              &nbsp;
            </span>
          </div>

          <div class="hide-on-mobile item center data-col-5">
            <h4 class="title">&nbsp;</h4>
            <span class="data">
              &nbsp;
            </span>
          </div>
          <div class="item center data-col-{{selected == 'active' ? getSpacing('status') : getSpacing('historyStatus')}}">
            <h4 class="title">STATO</h4>
            <span class="data">
              <select formControlName="Delivery.status">
                <option value="">Tutti</option>
                <option *ngFor="let dSActive of deliveryStatusAux['forInvoiced']" [value]="dSActive">
                  {{deliveryStatusAux.ln('it', dSActive)}}
                </option>
              </select>
            </span>
          </div>

          <div class="item data-col-{{getSpacing('id')}}">
            <h4 class="title" (click)="navigateOrder('Delivery.ddtNumber')">
              <i class="sort-icon fas" [ngClass]="orderIcon('Delivery.ddtNumber')"></i>
              ID VENDITA
            </h4>
            <span class="data">
              <input type="text" formControlName="Delivery.ddtNumber" min="1000" max="10000" >
            </span>
          </div>

          <div class="item data-col-{{getSpacing('id')}}">
            <h4 class="title" (click)="navigateOrder('Delivery.id')">
              <i class="sort-icon fas " [ngClass]="orderIcon('Delivery.id')"></i>
              ID
            </h4>
            <span class="data">
              <input type="number" formControlName="Delivery.id" min="1000" max="10000">
            </span>
          </div>

          <div class="item data-col-{{getSpacing('deliveryDate')}}">
            <h4 class="title" (click)="navigateOrder('Delivery.deliveryDate')">
              <i class="sort-icon fas" [ngClass]="orderIcon('Delivery.deliveryDate')"></i>
              DATA
            </h4>
            <span class="data">
              <div class="date">Da: </div>
              <input class="date" type="date" formControlName="Delivery.deliveryDate_from">
            </span>
            <span class="data">
              <div class="date">A: </div>
              <input class="date" type="date" formControlName="Delivery.deliveryDate_to">
            </span>
          </div>

          <div class="item center data-col-{{getSpacing('time')}}">
            <h4 class="title" (click)="navigateOrder(['Delivery.fromTime'])">
              <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.fromTime'])"></i>
              ORARIO
            </h4>
            <span class="data">
              <div class="date">Da: </div>
              <input class="date" type="time" formControlName="Delivery.fromTime">
            </span>
            <span class="data">
              <div class="date">A: </div>
              <input class="date" type="time" formControlName="Delivery.toTime">
            </span>
          </div>

          <div class="item data-col-{{getSpacing('partner')}}" *ngIf="groupWhitelisted(['admin', 'expert'])">
            <h4 class="title" (click)="navigateOrder('Partner.businessName')">
              <i class="sort-icon fas" [ngClass]="orderIcon('Partner.businessName')"></i>
              PARTNER
            </h4>
            <span class="data">
              <input type="text" formControlName="Partner.businessName"
                class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
            </span>
          </div>

          <div class="item data-col-{{getSpacing('expert')}}" *ngIf="groupWhitelisted('admin')">
            <h4 class="title" (click)="navigateOrder(['UserExpert.surname'])">
              <i class="sort-icon fas" [ngClass]="orderIcon(['UserExpert.surname'])"></i>
              EXPERT
            </h4>
            <span class="data"> 
              <input type="text" formControlName="UserExpert.surname">
            </span>
          </div>

          <div class="item data-col-{{getSpacing('address')}}">
            <h4 class="title" (click)="navigateOrder(['Delivery.address'])">
              <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.address'])"></i>
              INDIRIZZO
            </h4>

            <span class="data">
              <input type="text" formControlName="Delivery.address">
            </span>
          </div>

          <div class="item data-col-{{getSpacing('address')}}" *ngIf="groupWhitelisted('expert')">
            <h4 class="title">INDIRIZZO DI RITIRO</h4>
            <span class="data">
              <input type="text" formControlName="Delivery.partner.address">
            </span>
          </div>
          <div class="item data-col-30 pickUpTime">
            <h4 class="title" (click)="navigateOrder(['Delivery.pickUpTime', 'Delivery.pickUpTime'])">
              <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.pickUpTime', 'Delivery.pickUpTime'])"></i>
              ORA RITIRO
            </h4>
            <span class="data">
              <div class="date"></div>
              <input class="date" type="time" formControlName="Delivery.pickUpTime">
            </span>
          </div>

          <div class="item center data-col-5">
            <h4 class="title">TIPO SERVIZIO</h4>
            <span class="data">
              <select formControlName="Delivery.serviceType">
                <option [selected]="true" [disabled]="true">Tipo servizio</option>
                <option value="sales">Servizi Vendita</option>
                <option value="hourlyrate">Servizi a Ora</option>
                <option value="fixedprice">Servizi a Prezzo Fisso</option>
                <option value="corporate">Servizio aziendale</option>
                <option value="warehouseservice">Servizio Magazzino</option>
              </select>
            </span>
          </div>

          <div class="item center data-col-30" *ngIf="groupWhitelisted(['admin', 'expert', 'partner'])">
            <h4 class="title">DA FATTURARE</h4>
            <span class="data">
              <select formControlName="Delivery.billable" style="width: 120px;">
                <option value="">Tutti</option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </span>
          </div>

          <div class="item center data-col-30" *ngIf="groupWhitelisted(['admin', 'expert', 'partner'])">
            <h4 class="title">PAID WITH CARD</h4>
            <span class="data">
              <select formControlName="Delivery.paidViaCard" style="width: 120px;">
                <option value="">Tutti</option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </span>
          </div>

          <div class="item data-col-" >
            <h4 class="title" (click)="navigateOrder(['Delivery.productValue', 'Delivery.productValue'])">
              <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.productValue', 'Delivery.productValue'])"></i>
              VALORE PRODOTTO</h4>
            <span class="data">
              <input type="text" formControlName="Delivery.productValue">
            </span>
          </div>

          <div class="item data-col-" >
            <h4 class="title" (click)="navigateOrder(['Delivery.price', 'Delivery.price'])">
              <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.price', 'Delivery.price'])"></i>
              FEE %</h4>
            <span class="data">
              <input type="text" formControlName="Delivery.price">
            </span>
          </div>

          <div class="item data-col-" >
            <h4 class="title" (click)="navigateOrder(['Delivery.price', 'Delivery.price'])">
              <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.price', 'Delivery.price'])"></i>
              PREZZO</h4>
            <span class="data">
              <input type="text" formControlName="Delivery.price">
            </span>
          </div>

          <div class="item data-col-" >
            <h4 class="title" (click)="navigateOrder(['Delivery.additionalPrice', 'Delivery.additionalPrice'])">
              <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.additionalPrice', 'Delivery.additionalPrice'])"></i>
              PLUS MINUS PREZZO</h4>
            <span class="data">
              <input type="text" formControlName="Delivery.additionalPrice">
            </span>
          </div>

          <div class="item data-col-" >
            <h4 class="title" (click)="navigateOrder(['Delivery.additionalPrice', 'Delivery.additionalPrice'])">
              <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.additionalPrice', 'Delivery.additionalPrice'])"></i>
              VALORE</h4>
            <span class="data">
              <input type="text" formControlName="Delivery.additionalPrice">
            </span>
          </div>

          <div class="item data-col-" >
            <h4 class="title" (click)="navigateOrder(['Delivery.additionalPrice', 'Delivery.additionalPrice'])">
              <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.additionalPrice', 'Delivery.additionalPrice'])"></i>
              VALORE + IVA</h4>
            <span class="data">
              <input type="text" formControlName="Delivery.additionalPrice">
            </span>
          </div>

          <div class="item data-col-" >
            <h4 class="title" (click)="navigateOrder(['Delivery.additionalPrice', 'Delivery.additionalPrice'])">
              <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.additionalPrice', 'Delivery.additionalPrice'])"></i>
              TOTALE</h4>
            <span class="data">
              <input type="text" formControlName="Delivery.additionalPrice">
            </span>
          </div>

          <div class="item nowrap">
            <h4 class="title hide-on-mobile">AZIONI</h4>
            <span class="data-row-left btn-container">
              <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
                RICERCA <i class="fas fa-search"></i>
              </button>
                <br/>
              <button class="btn vertical align-items-center" (click)="fnReset();">
                RESET <i class="fas fa-times-circle"></i>
              </button>
            </span>
          </div>
        </form>

        <div class="table-row-container row" *ngIf="deliveries.length">
          <div class="select-all">
            <input type="checkbox" id="checkAll" style="cursor: pointer;" [checked]="selectedDeliveries.length === deliveries.length" (change)="selectAllDeliveries()" />
            <label for="checkAll" style="cursor: pointer;">Seleziona Tutti</label>
          </div>
        </div>
        <div class="table-row-container row" *ngFor="let delivery of deliveries">

          <div class="item data-col-5">
            <span class="data-row-left">
              <br>
              <input type="checkbox" style="cursor: pointer;"  [id]="'checkbox_' + delivery.id" [checked]="isSelected(delivery)" (change)="toggleSelection(delivery)" />
            </span>
          </div>


          <div class="item data-col-{{selected == 'active' ? getSpacing('status') : getSpacing('historyStatus')}}">
            <span class="data-row-left">
              <a *ngIf="groupWhitelisted('admin')">
                <span class="green-text" *ngIf="delivery.readDelivery && delivery.deliveryReadByPartner != null">
                  <i class="fa fa-check" aria-hidden="true"></i>&nbsp;
                </span>
                <span class="blue-text" *ngIf="delivery.readDelivery && delivery.deliveryReadByExpert != null">
                  <i class="fa fa-chevron-down" aria-hidden="true"></i>&nbsp;
                </span>

              </a>
            </span>
          </div>

          <div class="item center data-col-5">
            <h4 class="title">&nbsp;</h4>
            <img class="service-img" [src]="showServiceDetails(delivery?.service)?.image" width="40" height="40" *ngIf="showServiceDetails(delivery?.service)?.image">
          </div>

          <div class="item left-space data-col-{{selected == 'active' ? getSpacing('status') : getSpacing('historyStatus')}}">
            <span class="data-row-left">
              <h4 class="title">STATO :</h4>
              <a [ngClass]="delivery.status == 'delivering' ? 'blink' : ''">
                <span class="dataGesture">
                  <span [matTooltip]="deliveryStatusAux.ln('it', delivery.status)" class="status {{deliveryStatusAux.css(delivery.status)}}"></span>
                  {{deliveryStatusAux.ln('it', delivery.status)}}
                </span>
              </a>
            </span>
          </div>

          <div class="item data-col-{{getSpacing('id')}}">

            <span class="data-row-left">
              <h4 class="title table-title">ID VENDITA :</h4>
              <a>
                {{
                  delivery.correspondDelivery
                    ? delivery.correspondDelivery
                    : (delivery?.orderId && delivery?.externalOrderSource)
                      ? 'M' + delivery.orderId
                      : (delivery?.ddtNumber && !delivery?.externalOrderSource)
                        ? ((delivery.ddtNumber | saleName: delivery.shop) || delivery.ddtNumber)
                        : '---'
                }}
              </a>
            </span>
          </div>

          <div class="item data-col-{{getSpacing('id')}}">

            <span class="data-row-left">
              <h4 class="title table-title">ID :</h4>
              <a>
                {{delivery.id}}
              </a>
            </span>
          </div>

          <div class="item data-col-{{getSpacing('deliveryDate')}}">
            <span class="data-row-left">
              <h4 class="title table-title dataGesture">DATA :</h4>
              <a>
                {{delivery.deliveryDate | date:'dd/MM/yyyy'}}
              </a>
            </span>
          </div>

          <div class="item center data-col-{{getSpacing('time')}}">
            <span class="data-row-left">
              <h4 class="title table-title">ORARIO :</h4>
              <a *ngIf="delivery.toTime != null">{{formatTimeShow(delivery.fromTime, delivery.toTime)}}</a>
            </span>
          </div>

          <div class="item data-col-{{getSpacing('partner')}}" *ngIf="groupWhitelisted(['admin', 'expert'])">
            <span class="data-row-left">
              <h4 class="title table-title">PARTNER :</h4>
              <a>
                {{delivery.partner?.businessName}}
              </a>
            </span>
          </div>

          <div class="item data-col-{{getSpacing('expert')}}" *ngIf="groupWhitelisted('admin')">
            <span class="data-row-left">
              <h4 class="title table-title">EXPERT :</h4>
              <a>
                {{delivery.expert?.user?.surname}} {{delivery.expert?.user?.name}}
              </a>
            </span>
          </div>

          <div class="item data-col-{{getSpacing('address')}}">
            <span class="data-row-left tick">
              <h4 class="title table-title">INDIRIZZO :</h4>
              <a>
                {{((delivery.address ? delivery.address : "") + (delivery.city ? ", " + delivery.city : "")) || "---"}}
              </a>
            </span>
          </div>

          <div class="item data-col-{{getSpacing('address')}}" *ngIf="groupWhitelisted('expert')">
            <span class="data-row-left">
              <h4 class="title table-title">INDIRIZZO DI RITIRO :</h4>
              <a>
                {{delivery.partner?.address || "---"}}
              </a>
            </span>
          </div>

          <div class="item data-col-30 pickUpTime">
            <span class="data-row-left">
              <h4 class="title table-title">ORA RITIRO :</h4>
              <a>
                {{ delivery?.pickUpTime || "---"}}
              </a>
            </span>
          </div>
          
          <div class="item left-space data-col-5">
            <span class="data-row-left">
              <h4 class="title">TIPO SERVIZIO :</h4>
              <a>
                {{ delivery?.serviceType | serviceName }}
              </a>
            </span>
          </div>

          <div class="item left-space data-col-30" *ngIf="groupWhitelisted(['admin', 'expert', 'partner'])">
            <span class="data-row-left">
              <h4 class="title">DA FATTURARE :</h4>
              <a>
                {{
                  delivery?.billable ? "Yes" : "No"
                }}
              </a>
            </span>
          </div>

          <div class="item left-space data-col-30" *ngIf="groupWhitelisted(['admin', 'expert', 'partner'])">
            <span class="data-row-left">
              <h4 class="title">PAID WITH CARD :</h4>
              <a>
                {{
                  delivery?.paidViaCard ? "Yes" : "No"
                }}
              </a>
            </span>
          </div>

          <div class="item data-col-30 pickUpTime">
            <span class="data-row-left">
              <h4 class="title table-title">VALORE PRODOTTO:</h4>
              <a>
                {{ commanForValues(delivery).valoreProdotto | currency:'EUR' }}
              </a>
            </span>
          </div>

          <div class="item data-col-30 pickUpTime">
            <span class="data-row-left">
              <h4 class="title table-title">FEE %:</h4>
              <a>
                {{ commanForValues(delivery).fee }}%
              </a>
            </span>
          </div>

          <div class="item data-col-30 pickUpTime">
            <span class="data-row-left">
              <h4 class="title table-title">PREZZO:</h4>
              <a>
                {{ commanForValues(delivery).prezzo | currency:'EUR' }}
              </a>
            </span>
          </div>

          <div class="item data-col-30 pickUpTime">
            <span class="data-row-left">
              <h4 class="title table-title">PLUS MINUS PREZZO:</h4>
              <a>
                {{ commanForValues(delivery).plusMinusPrezzo | currency:'EUR' }}
              </a>
            </span>
          </div>

          <div class="item data-col-30 pickUpTime">
            <span class="data-row-left">
              <h4 class="title table-title">VALORE:</h4>
              <a>
                {{ commanForValues(delivery).valore | currency:'EUR' }}
              </a>
            </span>
          </div>

          <div class="item data-col-30 pickUpTime">
            <span class="data-row-left">
              <h4 class="title table-title">VALORE + IVA:</h4>
              <a>
                {{ commanForValues(delivery).valoreIva | currency:'EUR' }}
              </a>
            </span>
          </div>

          <div class="item data-col-30 pickUpTime">
            <span class="data-row-left">
              <h4 class="title table-title">TOTALE:</h4>
              <a>
                {{ commanForValues(delivery).totale | currency:'EUR' }}
              </a>
            </span>
          </div>

          <div class="item nowrap">
            <span class="data-row-left btn-container">
              <button class="btn vertical align-items-center" [routerLink]="['/consegne', delivery.id]">DETTAGLI</button>
              <button 
                class="btn vertical align-items-center" 
                (click)="complainForDeliveryBilling(delivery)" 
                *ngIf="groupWhitelisted(['partner']) && !delivery?.invoiced && !complaintAlredayRegistered(delivery)" 
                [disabled]="disableBtn">
                RECLAMA
              </button>
              <a target="_blank" class="btn vertical align-items-center"   [routerLink]="['/consegne', delivery.id, 'edit']" *ngIf="groupWhitelisted('admin')">MODIFICA</a>
              <button class="btn vertical align-items-center" [routerLink]="['/consegne', delivery.id, 'edit']" *ngIf="groupWhitelisted('partner') && (!delivery.deluxyDelivery) && (delivery.status == 'created' || delivery.status == 'delivered' || delivery.status == 'notDelivered')">MODIFICA</button>
            </span>
          </div>
        </div>

        <div class="table-row-container row total-row" *ngIf="deliveries.length">
          <div class="item data-col-5">
            <span class="data-row-left">
              <a>
                <strong></strong>
              </a>
            </span>
          </div>

          <div class="item data-col-">
            <span class="data-row-left">
              <a>
                <strong></strong>
              </a>
            </span>
          </div>

          <div class="item data-col-">
            <span class="data-row-left">
              <a>
                <strong></strong>
              </a>
            </span>
          </div>

          <div class="item data-col-">
            <span class="data-row-left">
              <a>
                <strong></strong>
              </a>
            </span>
          </div>

          <div class="item data-col-" *ngIf="groupWhitelisted('admin')">
            <span class="data-row-left">
              <a>
                <strong></strong>
              </a>
            </span>
          </div>

          <div class="item data-col-" *ngIf="groupWhitelisted('admin')">
            <span class="data-row-left">
              <a>
                <strong></strong>
              </a>
            </span>
          </div>

          <div class="item data-col-">
            <span class="data-row-left">
              <a>
                <strong></strong>
              </a>
            </span>
          </div>

          <div class="item data-col-">
            <span class="data-row-left">
              <a>
                <strong></strong>
              </a>
            </span>
          </div>

          <div class="item data-col-">
            <span class="data-row-left">
              <a>
                <strong></strong>
              </a>
            </span>
          </div>

          <div class="item data-col-">
            <span class="data-row-left">
              <a>
                <strong></strong>
              </a>
            </span>
          </div>

          <div class="item data-col-">
            <span class="data-row-left">
              <a>
                <strong></strong>
              </a>
            </span>
          </div>

          <div class="item data-col-">
            <span class="data-row-left">
              <a>
                <strong></strong>
              </a>
            </span>
          </div>

          <div class="item data-col-">
            <span class="data-row-left">
              <a>
                <strong></strong>
              </a>
            </span>
          </div>

          <div class="item data-col-">
            <span class="data-row-left">
              <a>
                <strong></strong>
              </a>
            </span>
          </div>

          <div class="item data-col-">
            <span class="data-row-left">
              <a>
                <strong>TOTALE</strong>
              </a>
            </span>
          </div>

          <div class="item data-col-">
            <span class="data-row-left">
              <a>
                <strong>{{ grandTotalValues.valoreProdotto | currency:'EUR' }}</strong>
              </a>
            </span>
          </div>

          <div class="item data-col-">
            <span class="data-row-left">
              <a>
                <strong>---</strong>
              </a>
            </span>
          </div>

          <div class="item data-col-">
            <span class="data-row-left">
              <a>
                <strong>{{ grandTotalValues.prezzo | currency:'EUR' }}</strong>
              </a>
            </span>
          </div>

          <div class="item data-col-">
            <span class="data-row-left">
              <a>
                <strong>{{ grandTotalValues.plusMinusPrezzo | currency:'EUR' }}</strong>
              </a>
            </span>
          </div>

          <div class="item data-col-">
            <span class="data-row-left">
              <a>
                <strong>{{ grandTotalValues.valore | currency:'EUR' }}</strong>
              </a>
            </span>
          </div>

          <div class="item data-col-">
            <span class="data-row-left">
              <a>
                <strong>{{ grandTotalValues.valoreIva | currency:'EUR' }}</strong>
              </a>
            </span>
          </div>

          <div class="item data-col-">
            <span class="data-row-left">
              <a>
                <strong>{{ grandTotalValues.totale | currency:'EUR' }}</strong>
              </a>
            </span>
          </div>

          <div class="item data-col-">
            <span class="data-row-left">
              <a>
                <strong></strong>
              </a>
            </span>
          </div>
        
        </div>
      </div>
    </div>
    <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>

</section>
-->

